export default "__VITE_ASSET__L7kpVrGp__"